// extracted by mini-css-extract-plugin
module.exports = {"top2":"IndexDom_top2__AEfVJ","fuceng":"IndexDom_fuceng__5cnvr","fuceng2":"IndexDom_fuceng2__M3TwU","height32":"IndexDom_height32__qaMe8"};